// src/components/dashboard/KPICard.tsx
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"; // Assuming shadcn Card
import { Skeleton } from "@/components/ui/skeleton"; // Assuming shadcn Skeleton

interface KPICardProps {
  title: string;
  value: number | string; // Allow string for formatted numbers potentially
  icon?: React.ReactNode; // Optional icon
  isLoading: boolean;
}

export default function KPICard({ title, value, icon, isLoading }: KPICardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {icon && <div className="text-muted-foreground">{icon}</div>}
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-8 w-24 mt-1" /> // Simple skeleton
        ) : (
          <div className="text-2xl font-bold text-foreground">
            {value}
          </div>
        )}
         {/* Optional: Add comparison or trend later */}
        {/* <p className="text-xs text-muted-foreground">+20.1% from last month</p> */}
      </CardContent>
    </Card>
  );
}